import { render, staticRenderFns } from "./purpose.vue?vue&type=template&id=45342bd9&"
import script from "./purpose.vue?vue&type=script&lang=js&"
export * from "./purpose.vue?vue&type=script&lang=js&"
import style0 from "./purpose.vue?vue&type=style&index=0&lang=css&scope=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports